<template>

    <div class="wrapper">
    <h3>【活動說明】</h3>
  <p>
    勞動部勞動力發展署國人海外就業中心(以下簡稱本中心)為鼓勵海內外國人分享自身海外就業/度假打工經驗，2022年4月20日起至2022年7月31日止，參與本次徵稿活動，投稿經採用者(以郵件通知為憑)即可獲得參加獎，活動後結束後還能角逐投稿金獎與海外達人金獎喔！
  </p>
    </div>

<div class="wrapper"><h3>【活動獎項】</h3>
  <p><ul>
    ★參加獎60名：可獲得電子禮券200元
    (獲獎規則：活動期間內投稿文章經採用並刊登，即可獲得參加獎，每位得獎者僅有一次獲獎機會，不得重覆領取，獲獎資格以稿件刊登於網站日期取前60名為準。若參加獎已額滿，將更新活動頁面，並同時在最新消息刊登公告)
    </ul>
    <ul>
        ★投稿金獎1名：可獲得電子禮券500元
        (獲獎規則：活動期間內單篇投稿文章獲得最多瀏覽數者。若有二篇文章瀏覽量相同，皆是最高瀏覽量，則以文章先刊登在本中心者為優勝者)
    </ul>
    <ul>
        ★海外達人金獎1名：可獲得電子禮券1,000元
        (評選資格：活動期間內投稿採用5篇以上，獲獎規則：活動期間內使用同一個信箱投稿且符合評選資格最多投稿篇數者。若同時有二位投稿者採用文章數量相同，皆為最多採用次數，則以最後一篇採用文章先刊登在本中心投稿者為優勝)
    </ul></p></div>
  
<div class="wrapper"><h3>【得獎人名單】</h3>
  <p><ul>
    <div class="member_list">★參加獎6名：可獲得電子禮券200元
    <ol v-for="member in participationAwardMembers" :key="member.email">
      {{
        member.name
      }}({{
        emailShow(member.email)
      }})
    </ol></div>
    
  </ul>
  <ul>
    <div class="member_list">★投稿金獎1名：可獲得電子禮券500元
    <ol v-for="member in goldAwardMembers" :key="member.email">
      {{
        member.name
      }}({{
        emailShow(member.email)
      }})
    </ol></div>

    
  </ul>
  <ul>
    <div class="member_list">★海外達人金獎1名：可獲得電子禮券1,000元

    <ol v-for="member in masterAwardMembers" :key="member.email">
      {{
        member.name
      }}({{
        emailShow(member.email)
      }})
    </ol></div>

    
  </ul></p></div>

  
  
  
<div class="wrapper"><h3>【獲獎須知】</h3>
  <p><ol>
    1.得獎者不得要求將本次活動獲獎轉讓、折換現金或更換其他獎項，本中心保留更換其他等值獎項之權利。
  </ol>
  <ol>
    2.每位參加者僅有乙次獲得參加獎機會，獲獎資格以稿件刊登於網站日期為準，若經本中心發現得獎者有重覆領取獎項情況，將取消得獎資格並由備取候補，得獎者不得異議。
  </ol>
  <ol>
    3.想獲取海外達人金獎獎項之投稿者，必須於活動期間內使用同一個信箱投稿且符合評選資格最多投稿篇數，才有機會獲得獎項，若投稿者使用不同信箱投稿，將無法累積投稿篇數，請特別注意。
  </ol>
  <ol>
    4.本次活動獎項為Edenred發行的電子禮劵，相關說明請參閱該公司網站（https://b2b.ticketxpress.com.tw/Home/Index）。活動獎項由皓展資訊股份有限公司贊助提供，得獎者若因使用而產生爭議，與本中心網站無關，請聯絡02-8995-6053。
  </ol>

  <ol>
    5.得獎者若於活動後經查不符合或違反本次活動投稿規範等相關事項者，本中心保留取消獲獎資格權利，已完成領獎情況應返還等值價金予本中心。
  </ol>

  <ol>
    6.得獎者在收到本中心發出得獎通知信件後，請依信中指定時間內提供領獎資訊，若得獎者無法於指定時間內提供領獎資訊，皆視為放棄得獎資格，恕不補發獎品，敬請見諒。
  </ol></p></div>

  

<div class="wrapper"><h3>【兌換辦法】</h3>
  <p><ol>
    1.活動期間結束後，統一由本中心網站公佈得獎資訊，並將以您投稿時留下之電子信箱，進行領獎通知核對及發送電子禮券。
  </ol>
  <ol>
    2.電子禮劵獎項有使用期限、無法退還、無法延展效期且逾期即失效之特性，若得獎者無法於期限內使用電子禮劵，視同得獎者自願放棄得獎資格，獎項將不另行補發。
  </ol></p></div>

  
  

<div class="wrapper"><h3>【活動注意事項】</h3>
  <p><ol>
    1.文章審稿通過與否，將依本中心採用/不採用原則為審核標準。
  </ol>
  <ol>
    2.本活動若有其他未盡事宜，活動辦法有任何變更或修改，依本中心活動網頁公告為主，不再另行通知。本中心保留隨時取消、終止、修改或暫停本活動權利，並保有最終釋義權。
  </ol>
  <ol>
    3.本活動若因任何非本中心可掌握之因素（包含但不僅限於以下原因），如電腦病毒、程式錯誤、駭客、電話、技術等，而造成本活動未如預期之規劃執行，致使侵害或影響其他參加者權益、活動公平與正當性…等情事，本中心將保留取消、終止、或修改及暫停本活動之權利；並可取消任何影響他人得獎權益之得獎者的得獎資格。以本活動網站公告為準，不另行通知。
  </ol>
  <ol>
    4.參與活動之投稿者，如有違反本活動辦法，或以惡意之電腦程式或其他明顯違反活動公平性之方式，意圖混淆或影響活動結果者，一經本中心發現或經第三人檢舉經查證屬實，本中心有權利立即取消其資格，除追回獎品外，並對於任何破壞本活動之行為保留法律追訴權。
  </ol>
  <ol>
    5.參加者保證所有填寫或提出之資料均為真實、正確，且未冒用或盜用任何第三人之資料，如因得獎者資料不實或填寫不正確或不完整導致無法通知獎項者，視同得獎者自願放棄得獎資格，獎項將不另行補發。
  </ol>
  <ol>
    6.參與本次活動於提交個人資料後，請問你是否同意接受勞動部勞動力發展署中心網站及本次活動注意事項之規範，如有違反之情事，勞動部勞動力發展署中心得取消其得獎資格，並對任何影響活動正當性行為，保留相關法律權利。
  </ol></p></div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  setup() {
    const participationAwardMembers = [
      { name: "Fanny Lee", email: "yifenlee@yahoo.com.tw" },
      { name: "Aurora", email: "cyms2715@gmail.com" },
      { name: "JOJOinNZ", email: "good-day-joan@hotmail.com" },
      { name: "曉陽", email: "startracy115@gmail.com" },
      { name: "我是TOBY9988", email: "toby998808@gmail.com" },
      { name: "Jack Tsai", email: "jack402234@gmail.com" },
    ];
    const goldAwardMembers = [{ name: "Aurora", email: "cyms2715@gmail.com" }];
    const masterAwardMembers = [
      { name: "曉陽", email: "startracy115@gmail.com" },
    ];
    const emailShow = (email) => {
      const emailList = email.split("@");
      const emailStart = email.indexOf("@");
      let mockStr = "";
      for (let i = 0; i < emailStart - 3; i++) {
        mockStr = mockStr + "*";
      }

      return email.substr(0, 3) + mockStr + "@" + emailList[1];
    };
    return {
      participationAwardMembers,
      goldAwardMembers,
      masterAwardMembers,
      emailShow,
    };
  },
});
</script>

<style lang="scss" scoped>
.wrapper {
  text-align: left;
  margin-bottom: 15px;
  h3 {
    font-size: 1.25em;
    margin-bottom: 5px;
  }
  .member_list {
    margin-bottom: 15px;
  }
  p {
    ol,
    ul {
      font-size: 1em;
    }
  }
}
</style>
